import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import { IFileAttachment } from '@kodit/core/data-api';
import { Injectable } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class RelevantniDokumentListItemFormService {
  constructor(private _fb: FormBuilderTypeSafe) {}

  public GetFormArray(listData: IFileAttachment[]): FormArray {
    if (!listData || listData.length === 0) {
      return this._fb.array([]);
    }

    const result: FormArray = this._fb.array([]);
    listData.forEach((x) => {
      result.push(this.GetFormGroup(x));
    });
    return result;
  }

  public GetFormGroup(
    model?: IFileAttachment
  ): FormGroupTypeSafe<IFileAttachment> {
    return this._fb.group<IFileAttachment>({
      path: new FormControl(model?.path),
      contentType: new FormControl(model?.contentType),
      name: new FormControl(model?.name),
      tip: new FormControl(model?.tip),
    });
  }
}
